<div fxLayout="column" fxFlexFill style="position: relative">
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table
      [dataSource]="dataSource"
      [multiTemplateDataRows]="true"
      class="regular-table padding-left-10"
      matSort
      matSortActive="start"
      matSortDirection="desc"
      matSortDisableClear
    >
      <ng-container matColumnDef="expand">
        <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button mat-mini-fab class="button-32 no-shadow expand-btn" (click)="expandDetails(row)">
            <mat-icon *ngIf="!row.isExpanded">expand_more</mat-icon>
            <mat-icon *ngIf="row.isExpanded">expand_less</mat-icon>
          </button>
        </mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="domainAlias">
        <mat-header-cell *matHeaderCellDef mat-sort-header="domain">Company</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.domainAlias }}</mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="start">
        <mat-header-cell *matHeaderCellDef mat-sort-header="start">Date & Time</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.start | dateTime: 'M/dd/yyyy hh:mm a' }} </mat-cell>
        <mat-footer-cell *matFooterCellDef>Total: {{ aggregates?.total }}</mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="from">
        <mat-header-cell *matHeaderCellDef>From</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.fromNumber | phoneNumber }} - {{ row.fromName }} </mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="to">
        <mat-header-cell *matHeaderCellDef>To</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.toNumber | phoneNumber }} - {{ row.toName }} </mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="callType">
        <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span
            [ngClass]="{
              'badge-outgoing': row.callType === 'Outgoing',
              'badge-internal': row.callType === 'Internal',
              'badge-incoming': row.callType === 'Incoming' || row.callType === 'Group',
            }"
          >
            <i class="material-icons">
              {{
                row.callType === 'Outgoing'
                  ? 'call_made'
                  : row.callType === 'Internal'
                    ? 'import_export'
                    : 'call_received'
              }}
            </i>
            {{ row.callType }}
          </span>
        </mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="callStatus">
        <mat-header-cell *matHeaderCellDef>Call Result</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <div>
            <span style="vertical-align: middle">{{
              row.callType === 'Outgoing' && (row.callStatus === 'Answered' || row.callStatus === 'Missed')
                ? '-'
                : row.callStatus
            }}</span>
            <mat-icon
              style="vertical-align: middle; margin-left: 5px"
              fontSet="material-icons-outlined"
              *ngIf="row.reason && row.callStatus !== 'Hung Up'"
              [matTooltip]="row.reasonH"
              >info</mat-icon
            >
          </div>
        </mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="answeredBy">
        <mat-header-cell *matHeaderCellDef>Answered By</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.answeredByH }}</mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="missedBy">
        <mat-header-cell *matHeaderCellDef>Missed By</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.missedByH }}</mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="durationIvr">
        <mat-header-cell *matHeaderCellDef>IVR Time</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.durationIvr | duration }}</mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="durationRing">
        <mat-header-cell *matHeaderCellDef>Ring Time</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.durationRing | duration }}</mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="durationTalk">
        <mat-header-cell *matHeaderCellDef>Talk Time</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.durationTalk | duration }}</mat-cell>
        <mat-footer-cell *matFooterCellDef>{{ aggregates?.totalTalkDuration | duration }}</mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="durationHold">
        <mat-header-cell *matHeaderCellDef>Hold Time</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.durationHold | duration }}</mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="durationTotal">
        <mat-header-cell *matHeaderCellDef>Total Time</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.durationTotal | duration }}</mat-cell>
        <mat-footer-cell *matFooterCellDef>{{ aggregates?.totalDuration | duration }}</mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="recordings">
        <mat-header-cell *matHeaderCellDef>Recordings</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <div class="recordings-control" *ngFor="let recording of row.recordings">
            <button
              *ngIf="!!recording.transcriptionInfo"
              mat-icon-button
              class="button-32"
              matTooltip="Recording transcription details"
              (click)="openTranscriptionInfo(recording)"
            >
              <mat-icon>description</mat-icon>
            </button>

            <ng-container *ngIf="recording.file">
              <button
                mat-icon-button
                class="button-32"
                (click)="playRecording(row, recording)"
                matTooltip="Play {{ recording.extension }} {{ recording.extensionName }}"
              >
                <mat-icon>play_arrow</mat-icon>
              </button>
              <a
                mat-icon-button
                class="button-32"
                *ngIf="reportsService.userRights.recordingsDownload"
                target="_blank"
                href="{{ this.getDownloadUrl(row, recording) }}"
                matTooltip="Download Recording"
              >
                <mat-icon>download</mat-icon>
              </a>
              <button
                mat-icon-button
                class="button-32"
                color="warn"
                *ngIf="isRecordingOnlySupport(row)"
                matTooltip="This recording is visible only for support"
              >
                <mat-icon>warning</mat-icon>
              </button>
            </ng-container>

            <button
              mat-icon-button
              class="button-32"
              *ngIf="reportsService.userRights.recordingsDelete && (recording.file || recording.transcriptionInfo)"
              (click)="
                onDeleteRecordingConfirm({
                  callId: row.callRecId,
                  recId: recording.recId,
                  cdrDate: row.start,
                  domain: row.domain,
                  hasTranscription: !!recording.transcriptionInfo,
                  hasRecording: !!recording.file,
                })
              "
              [matTooltip]="getDeleteIconLabel(recording)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="surveys">
        <mat-header-cell *matHeaderCellDef>Survey Results</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <div *ngFor="let survey of row.surveyResults">
            <div>
              <span>{{ survey.accountName }}</span>
              <span style="padding-left: 5px">({{ survey.rate }})</span>
            </div>
          </div>
        </mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
          <div
            class="mat-detail-container call-flow-details"
            [@detailExpand]="row.isExpanded ? 'expanded' : 'collapsed'"
          >
            <mat-progress-spinner
              *ngIf="row.isLoading"
              mode="indeterminate"
              diameter="50"
              strokeWidth="2"
              style="margin: 50px"
            ></mat-progress-spinner>

            <h3 *ngIf="!row.isLoading">
              Call Flow Details
              <button
                mat-icon-button
                class="button-32"
                *ngIf="hasSupportAccess"
                (click)="getCallDetails(row.callId, row.domain)"
              >
                <mat-icon>info_outline</mat-icon>
              </button>
            </h3>
            <mat-table
              class="call-flow-details-table"
              [dataSource]="row.humanizedStates"
              *ngIf="row.isExpanded && !row.isLoading"
            >
              <ng-container matColumnDef="eventName">
                <mat-header-cell *matHeaderCellDef>Stage</mat-header-cell>
                <mat-cell *matCellDef="let state">
                  <mat-icon class="call-flow-icon event" *ngIf="state.eventName === 'Event'">import_export</mat-icon>
                  <mat-icon class="call-flow-icon incoming" *ngIf="state.eventName === 'Incoming'"
                    >phone_callback
                  </mat-icon>
                  <mat-icon class="call-flow-icon outgoing" *ngIf="state.eventName === 'Outgoing'"
                    >phone_forwarded
                  </mat-icon>
                  <mat-icon class="call-flow-icon mail" *ngIf="state.eventName === 'Mailbox'">mail</mat-icon>
                  <mat-icon class="call-flow-icon call-progress" *ngIf="state.eventName === 'Call Progress'">
                    phone_in_talk
                  </mat-icon>
                  <mat-icon class="call-flow-icon hang-up" *ngIf="state.eventName === 'Hang up'">call_end</mat-icon>
                  {{ state.eventTitle }}
                </mat-cell>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="time">
                <mat-header-cell *matHeaderCellDef>Time</mat-header-cell>
                <mat-cell *matCellDef="let state">{{ state.time | dateTime: 'hh:mm:ss a' }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="duration">
                <mat-header-cell *matHeaderCellDef>Duration</mat-header-cell>
                <mat-cell *matCellDef="let state">
                  <span *ngIf="state.duration > 0">{{ state.duration | duration }}</span>
                  <span *ngIf="!state.duration">&nbsp;</span>
                </mat-cell>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="details">
                <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                <mat-cell *matCellDef="let state">{{ state.details }}</mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="['eventName', 'duration', 'details']"></mat-header-row>
              <mat-row *matRowDef="let row; columns: ['eventName', 'duration', 'details']"></mat-row>
            </mat-table>
          </div>
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        [class.marked-row]="currentAudioModel?.callId === row.callRecId"
        [class.mat-expanded-row]="row.isExpanded"
        class="call-logs-row"
      ></mat-row>
      <mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></mat-footer-row>

      <!-- Extra row to show detail content column -->
      <mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="mat-details-row"
        [class.mat-expanded-detail-row]="row.isExpanded"
      ></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
  <div class="recordings-control-container">
    <app-audio-control
      #audioPlayer
      [src]="currentAudioSource"
      [downloadSrc]="currentAudioDownloadSource"
      [showDelete]="reportsService.userRights.recordingsDelete"
      [showDownload]="reportsService.userRights.recordingsDownload"
      [autoPlay]="true"
      [title]="currentAudioTitle"
      [data]="currentAudioModel"
      (errorEmitter)="onAudioError($event)"
      (deleteEmitter)="onDeleteRecordingConfirm($event)"
      (onCloseEmitter)="onAudioPlayerClose($event)"
    ></app-audio-control>
  </div>
</div>
